import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import siteConfig from '@/config/siteConfig';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Defaults gespiegelt aus siteConfig
const defaultClubInfo = {
  name: siteConfig.clubInfo.name,
  foundingYear: siteConfig.clubInfo.foundingYear,
  addressStreet: siteConfig.contact.address.street,
  addressZip: siteConfig.contact.address.zip,
  addressCity: siteConfig.contact.address.city,
  phone: siteConfig.contact.phone,
  phoneHours: siteConfig.contact.phoneHours,
  email: siteConfig.contact.email,
  members: siteConfig.stats.members,
  ridingLessonsPerWeek: siteConfig.stats.ridingLessonsPerWeek,
  yearsOfTradition: siteConfig.stats.yearsOfTradition,
  areaHectares: siteConfig.stats.areaHectares,
  virtualTourUrl: '',
  easyVereinJoinUrl: '',
  interactiveMapVisible: false,
};

const ClubInfoContext = createContext({
  clubInfo: defaultClubInfo,
  loading: true,
  refresh: () => {},
});

export const ClubInfoProvider = ({ children }) => {
  const [clubInfo, setClubInfo] = useState(defaultClubInfo);
  const [loading, setLoading] = useState(true);

  const fetchClubInfo = useCallback(async () => {
    try {
      const res = await axios.get(`${BACKEND_URL}/api/club-info`);
      if (res.data) {
        setClubInfo({ ...defaultClubInfo, ...res.data });
      }
    } catch (err) {
      console.error('ClubInfo konnte nicht geladen werden:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchClubInfo();
  }, [fetchClubInfo]);

  return (
    <ClubInfoContext.Provider value={{ clubInfo, loading, refresh: fetchClubInfo }}>
      {children}
    </ClubInfoContext.Provider>
  );
};

export const useClubInfo = () => useContext(ClubInfoContext);

export default ClubInfoContext;
